/* eslint-disable @typescript-eslint/no-explicit-any */
export const booleanArrayToCount = (array: any[]): number => {
  return array.reduce((count, value) => count + (value ? 1 : 0), 0);
};
